import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const initialState: any | null = {};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<any>) => {
      console.log("PAYLOAD REDUX", action.payload);
      state.config = action.payload;
    },
  },
});

export const { setConfig } = configSlice.actions;

export const selectConfig = (state: RootState) => state.config;
export default configSlice.reducer;
